export default "__VITE_ASSET__BBTIRek___"